<template>
  <div v-if="item" class="property-detail">
    <div fluid style="poition:relative;">
      <photos v-if="item" :images="item.images"></photos>
      <v-breadcrumbs
        v-if="geocoder"
        :items="breadcrumbs"
        dark
        divider=">"
        class="advert-breadcrumbs"
      >
        <template v-slot:item="props">
          <v-breadcrumbs-item
            :href="props.item.href"
            @click.prevent="inverseSearch(props.item.query)"
            class="primary--text"
            :class="[props.item.disabled && 'disabled']"
          >{{ props.item.text }}</v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
      <!-- Issue # FLATS-SCS-3 -->
      <!-- <div class="py-8"></div> -->

      <div style="position:absolute;top:0;right:0;left:0;z-index:1;">
        <v-container>
          <v-row>
            <v-col cols="auto" class="ml-auto mr-3">
              <v-btn
                dark
                fab
                small
                :color=" 'blue-grey darken-4'"
                :loading="favoriting"
                v-if="!user_is_owner"
                @click="toggleFavorite"
              >
                <v-icon dark :color="is_favorited ? 'pink' : 'white'">mdi-heart</v-icon>
                <!-- <span>{{ is_favorited ? trans('advert.is_favorited') : trans('advert.add_to_favorites') }}</span> -->
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>

    <v-container class="fill-height">
      <v-row cols="12">
        <v-col cols="12" md="8">
          <!-- <v-list> -->
          <v-row>
            <v-col cols="12">
              <v-list-item three-line class="px-0">
                <v-list-item-content>
                  <v-list-item-title class="text-wrap">
                    <h1>{{ item.title }}</h1>
                  </v-list-item-title>
                  <v-list-item-subtitle>{{ trans('advert.property_type_' + item.property_type) }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <!-- <v-col cols="2" class="d-flex flex-column align-center">
              <div>
                <v-list-item-avatar :size="48" color="secondary" class="mr-0">
                  <v-flex class="text-center white--text">{{ inititals }}</v-flex>
                </v-list-item-avatar>
              </div>

              <v-list-item-title>{{ full_name || 'Anonymus' }}</v-list-item-title>
            </v-col>-->
          </v-row>

          <!-- </v-list> -->

          <v-row no-gutters class="mb-3">
            <v-col cols="4">
              <v-list-item two-line class="px-0">
                <v-list-item-avatar>
                  <v-icon dark color="grey">mdi-home</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Amount of rooms</v-list-item-title>
                  <v-list-item-subtitle>{{ item.room_amount }} rooms</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="4">
              <v-list-item two-line class="px-0">
                <v-list-item-avatar>
                  <v-icon dark color="grey">mdi-account-supervisor</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Amount of guests</v-list-item-title>
                  <v-list-item-subtitle>{{ item.occupants }} guests</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="4">
              <v-list-item two-line class="px-0">
                <v-list-item-avatar>
                  <v-icon dark color="grey">mdi-ruler-square</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ trans('advert.area') }}</v-list-item-title>
                  <v-list-item-subtitle>{{ item.area }} {{ trans('advert.area_unit_' + item.area_unit) }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="4">
              <v-list-item two-line class="px-0">
                <v-list-item-avatar>
                  <v-icon dark color="grey">mdi-account-multiple-outline</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Room Size</v-list-item-title>
                  <v-list-item-subtitle>{{ item.room_size || '-'}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>

          <v-divider></v-divider>

          <div class="my-3 py-3">
            <h2 class="mb-3">{{ trans('advert.view_description') }}</h2>
            <div>{{ item.description }}</div>
          </div>
          <v-divider></v-divider>

          <div class="my-3 py-3">
            <h2 class="mb-3">{{ trans('advert.view_tenant_preferences') }}</h2>
            <tenant-preferences :advert="item"></tenant-preferences>
          </div>
          <v-divider></v-divider>

          <div class="my-3 py-3" v-if="item.property_type == 'room'">
            <h2 class="mb-3">{{ trans('advert.view_flatmate_preferences') }}</h2>
            <flatmate-preferences :advert="item"></flatmate-preferences>
          </div>
          <v-divider v-if="item.property_type == 'room'"></v-divider>

          <div class="my-3 py-3">
            <h2 class="mb-3">{{ trans('advert.view_amenities') }}</h2>
            <info-list type="amenities" :items="item.amenities"></info-list>
          </div>
          <v-divider></v-divider>

          <div class="my-3 py-3">
            <h2 class="mb-3">{{ trans('advert.view_facilities') }}</h2>
            <info-list type="facilities" :items="item.facilities"></info-list>
          </div>
          <v-divider></v-divider>

          <div class="my-3 py-3">
            <h2 class="mb-3">{{ trans('advert.transport_mode') }}</h2>
            <transport :item="item"></transport>
          </div>
          <v-divider></v-divider>

          <div class="my-3 py-3">
            <h2 class="mb-3">{{ trans('advert.view_location') }}</h2>
            <div>
              <advert-on-map v-if="item.location" :location="item.location"></advert-on-map>
            </div>
          </div>
        </v-col>

        <!-- RIGHT COLUMN -->

        <v-col cols="12" md="4" class="property-detail-price">
          <!-- 1st box: Price + availability - as it's now -->
          <v-card class="my-3">
            <v-card-text>
              <div class="black--text">
                <span class="display-1" v-if="item.bills_included != 'yes'">~</span>
                <span class="display-1">{{ item.price_total }}</span>
                <span>{{ trans('advert.price_currency_'+item.price_currency) }} / {{ trans('advert.rent_period_'+item.rent_period) }}</span>
              </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text>
              <!--
                <div class="mt-2">
                  <div>
                    <span>{{ trans('advert.bills_included') }} - </span> 
                    <span>{{ trans('advert.bills_included_' + item.bills_included) }} </span> 
                  </div>
                  <div v-if="item.bills_included != 'yes'">
                    <span>{{ trans('advert.price_rent') }} </span>
                    <span class="subtitle-1 font-weight-bold">{{ item.price_value }}</span>
                    <span class="font-weight-bold">{{ trans('advert.price_currency_'+item.price_currency) }}</span>
                    <span> + </span>
                    <span>{{ trans('advert.price_bills') }} </span>
                    <span class="subtitle-1 font-weight-bold">{{ item.est_bill_amount || '0.00' }}</span>
                    <span class="font-weight-bold">{{ trans('advert.price_currency_'+item.price_currency) }}</span>
                  </div>
                </div>
              -->

              <v-list-item :two-line="false" class="px-0">
                <v-list-item-avatar class="my-0">
                  <v-icon>mdi-cash-multiple</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    <span>{{ trans('advert.bills_included_' + item.bills_included + '_alt') }}</span>
                  </v-list-item-title>
                  <v-list-item-subtitle v-if="(item.bills_included != 'yes')">
                    <span>{{ trans('advert.price_rent') }}</span>
                    <span class="font-weight-bold ml-1">{{ item.price_value }}</span>
                    <span
                      class="font-weight-bold mr-1"
                    >{{ trans('advert.price_currency_'+item.price_currency) }}</span>
                    <span>+</span>
                    <span>{{ trans('advert.price_bills') }}</span>
                    <span class="font-weight-bold ml-1">{{ item.est_bill_amount || '0.00' }}</span>
                    <span
                      class="font-weight-bold"
                    >{{ trans('advert.price_currency_'+item.price_currency) }}</span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item :two-line="false" class="px-0">
                <v-list-item-avatar class="my-0">
                  <v-icon>mdi-calendar</v-icon>
                </v-list-item-avatar>
                <v-list-item-content v-if="!is_available">
                  <v-list-item-subtitle>{{ trans('advert.available_from') }}</v-list-item-subtitle>
                  <v-list-item-title>{{ from_date }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-content v-if="is_available">
                  <v-list-item-title>{{ trans('advert.available_from_now') }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-card-text>
          </v-card>

          <advert-author v-if="item.author && !user_is_owner" v-bind="item.author" :advert="item">
            <v-card-text v-if="!user_is_owner">
              <div>
                <v-btn
                  @click="toggleInAHurry"
                  large
                  block
                  rounded
                  color="secondary"
                  :outlined="!is_reserved"
                  :loading="reserving"
                >
                  <v-icon left small v-if="!!is_reserved">mdi-check</v-icon>
                  <span>{{ trans('advert.in_a_hurry_true') }}</span>
                </v-btn>
              </div>
              <div
                v-if="is_reserved"
                class="mt-2 text-center"
              >{{ trans('advert.in_a_hurry_active_description') }}</div>
              <div
                v-else
                class="secondary--text mt-2 text-center"
              >{{ trans('advert.in_a_hurry_description') }}</div>
            </v-card-text>

            <v-divider v-if="!user_is_owner"></v-divider>
            <div
              class="caption font-weight-bold text-center mt-2"
            >{{ trans('advert.title_complaint', null ,'Complaint') }}</div>
            <v-card-text v-if="!user_is_owner">
              <v-layout column grid-list-lg>
                <v-flex>
                  <!-- reportUnavailable -->
                  <v-btn
                    @click="unavailable_modal = true"
                    :loading="instance_reporting == uuid"
                    large
                    block
                    primary
                    text
                  >
                    <v-icon v-if="instance_reported == uuid">mdi-check</v-icon>
                    <span>{{ trans('advert.report_unavailable') }}</span>
                  </v-btn>

                  <v-btn
                    v-if="!report_active"
                    @click="reportAdvert"
                    large
                    block
                    primary
                    text
                  >{{ trans('advert.report_advert') }}</v-btn>

                  <div class="mx-n3">
                    <report
                      v-if="report_active"
                      :key="uuid"
                      :subject_uuid="uuid"
                      @cancel="report_active = false"
                      @close="report_active = false"
                    ></report>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </advert-author>

          <interested-users v-if="user_is_owner" :users="interesting_people"></interested-users>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="unavailable_modal" max-width="290">
      <v-card>
        <v-card-text
          class="py-2 title text-center"
        >{{ trans('advert.report_submit_question',null, 'Are you sure that this property is not available?') }}</v-card-text>

        <v-card-actions class="d-flex justify-center">
          <v-btn
            color="primary"
            rounded
            text
            @click="unavailable_modal = false"
          >{{ trans('advert.report_cancel_btn',null, 'Cancel') }}</v-btn>

          <v-btn
            color="primary"
            dark
            rounded
            @click="reportUnavailable"
          >{{ trans('advert.report_submit_btn',null, 'Yes') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import EventBus from "../event_bus";
import { mapGetters, mapActions, mapState } from "vuex";
import AdvertAuthor from "../components/AdvertAuthor";
import AdvertOnMap from "../components/AdvertOnMap";
import InfoList from "../components/advert-details/InfoList";
import TenantPreferences from "../components/advert-details/TenantPreferences";
import FlatmatePreferences from "../components/advert-details/FlatmatePreferences";
import Photos from "../components/advert-details/Photos";
import Report from "../components/advert-details/Report";
import InterestedUsers from "../components/advert-details/InterestedUsers";
import Transport from "../components/advert-details/Transport";

import store from "../store";

export default {
  name: "AdvertDetails",

  components: {
    "advert-author": AdvertAuthor,
    "advert-on-map": AdvertOnMap,
    "info-list": InfoList,
    "tenant-preferences": TenantPreferences,
    "flatmate-preferences": FlatmatePreferences,
    photos: Photos,
    report: Report,
    "interested-users": InterestedUsers,
    transport: Transport
  },

  data: () => ({
    active: true,
    report_active: false,
    process_in_a_hurry: false,
    process_favorite: false,
    geocoder: null,
    unavailable_modal: false
  }),

  computed: {
    ...mapState("search", {
      item: "item"
    }),
    ...mapState("auth", {
      authenticated: "authenticated",
      auth_uuid: "user"
    }),
    ...mapGetters("search", {
      isLoading: "isLoading"
    }),
    ...mapState("adverts", {
      instance_reporting: "instance_reporting",
      instance_reported: "instance_reported"
    }),

    uuid: function() {
      return this.$route.params.uuid;
    },

    loading: function() {
      return this.isLoading("show");
    },

    favoriting: function() {
      return this.isLoading("favoriting");
    },

    reserving: function() {
      return this.isLoading("reserving");
    },

    breadcrumbs: function() {
      if (!this.item) return null;
      let breadcrumbs = [];
      let segments = ["country", "locality", "sublocality", "route"];
      let query = "";
      _.each(segments, row => {
        let segment = _.get(this.item.location, row);
        if (segment) {
          query = query + segment + " ";
          breadcrumbs.push({
            text: segment,
            // disabled: row == "route",
            query: query.trim(),
            href: "/find-a-place?q=" + encodeURIComponent(query.trim())
          });
        }
      });
      return breadcrumbs;
    },

    is_available: function() {
      let diff = moment(this.item.available_from).utcOffset(60) - new Date();
      return diff < 0;
    },

    from_date: function() {
      if (this.is_available) {
        return this.trans("advert.available_from_now");
      } else {
        return moment(this.item.available_from)
          .utcOffset(60)
          .locale("en")
          .format("LL");
      }
    },

    show_flatmate_preferences: function() {
      return (
        _.get(this.item, "property_type", null) == "room" &&
        _.get(this.item, "occupants_amount", 0) > 1
      );
    },

    is_favorited: function() {
      return _.get(this.item, "is_favorited", false);
    },

    is_reserved: function() {
      return _.get(this.item, "is_reserved", false);
    },

    interesting_people: function() {
      return _.get(this.item, "interesting", []);
    },

    user_is_owner: function() {
      return _.get(this.item, "created_by", "-") == this.auth_uuid;
    },
    last_name() {
      return this.item.author.last_name;
    },
    first_name() {
      return this.item.author.first_name;
    },
    full_name: function() {
      if (this.last_name) {
        return `${this.first_name} ${this.last_name}`;
      } else {
        return this.first_name;
      }
    },

    inititals: function() {
      if (!this.first_name) return "A";
      let inititals = this.first_name.charAt(0);
      if (this.last_name) {
        inititals = inititals + "" + this.last_name.charAt(0);
      }
      return _.toUpper(inititals);
    }
  },

  methods: {
    ...mapActions("search", {
      load: "show",
      addToInteresting: "addToInteresting",
      removeFromInteresting: "removeFromInteresting",
      addToFavorites: "addToFavorites",
      removeFromFavorites: "removeFromFavorites",
      // ++
      setQueryParam: "setQueryParam",
      resetQuery: "resetQuery"
    }),
    ...mapActions("adverts", {
      report: "report"
    }),

    reportAdvert: function() {
      if (!this.authenticated) return EventBus.$emit("requiresAuth", null);
      this.report_active = !this.report_active;
    },

    reportUnavailable: function() {
      if (!this.authenticated) return EventBus.$emit("requiresAuth", null);
      this.unavailable_modal = false;
      this.report(this.uuid);
    },

    inverseSearch: function(query_string) {
      let query = {
        address: query_string
      };
      this.geocoder.geocode(query, (results, status) => {
        if (status == "OK") {
          let place = results[0];

          let data = {
            address_components: _.get(place, "address_components", []),
            formatted_address: _.get(place, "formatted_address"),
            geometry: {
              location: _.get(place, "geometry.location").toJSON(),
              viewport: _.get(place, "geometry.viewport").toJSON()
            },
            place_id: _.get(place, "place_id")
          };
          let location = Object.assign(
            {},
            data,
            _.get(place, "geometry.viewport").toJSON()
          );

          this.resetQuery();
          this.setQueryParam({ location: location });
          this.$router.push({ name: "search" });
        }
      });
    },

    toggleInAHurry: function() {
      if (!this.authenticated) return EventBus.$emit("requiresAuth", null);
      if (!this.is_reserved) {
        this.addToInteresting(this.$route.params.uuid);
      } else {
        this.removeFromInteresting(this.$route.params.uuid);
      }
    },

    toggleFavorite: function() {
      if (!this.authenticated) return EventBus.$emit("requiresAuth", null);
      if (!this.is_favorited) {
        this.addToFavorites(this.$route.params.uuid);
      } else {
        this.removeFromFavorites(this.$route.params.uuid);
      }
    }
  },

  created: function() {
    this.load(this.$route.params.uuid);
  },

  mounted: function() {
    this.$google.then(google => {
      this.geocoder = new google.maps.Geocoder();
    });
  },

  beforeRouteEnter(to, from, next) {
    // store.dispatch('search/show', to.params.uuid).then(r => next());
    next(vm => {
      to.meta.title =
        to.params.uuid + " — " + vm.trans("app.page_advert_details");
    });
  }
};
</script>
<style lang="scss" scoped>
.property-detail-price {
  margin-top: -120px;
  z-index: 4;
}
.property-detail {
  background: #fff;
}
</style>